package com.ives.components.workspace;

import com.ives.utils.math.Vector3D;

class OrientationSide {
	public var position:Vector3D;
	public var label:String;

	public function new(position:Vector3D, label:String) {
		this.position = position;
		this.label = label;
	}
}
